require('select2');

$(document).ready(function() {
  $('.form-group--select select').select2({
    width: 'resolve'
  });
});
